import ReactNativeWebView from './ReactNativeWebView';

export const POST_MESSAGE_TO_RN_WEBVIEW_ERROR = 'Error: The app must be contained within a ReactNative Webview component to use this service.';

export const PostMessageToRnWebview = (data = {}) => {
    try {
        ReactNativeWebView.postMessage(JSON.stringify(data));
    } catch (err) {
        return Promise.reject(POST_MESSAGE_TO_RN_WEBVIEW_ERROR);
    }
    return Promise.resolve();
};

export default PostMessageToRnWebview;